import React from 'react'
import tenantConfig from 'config/tenant'
import './Loader.scss'

export interface LoaderProps {
  message?: string
  size?: 'sm' | 'md' | 'lg'
  overlay?: boolean
}

const Loader: React.FC<LoaderProps> = ({
  message = 'Loading, please wait...',
  size = 'lg',
  overlay = true
}) => {
  return (
    <div
      className={`insurance-loader${overlay ? ' insurance-loader--overlay' : ''}`}
      data-testid="loader"
    >
      <div className={`insurance-loader__ring insurance-loader__ring--${size}`}>
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          {/* Background track */}
          <circle
            cx="50"
            cy="50"
            r="44"
            fill="none"
            className="insurance-loader__track"
          />
          {/* Spinning arc - primary */}
          <circle
            cx="50"
            cy="50"
            r="44"
            fill="none"
            className="insurance-loader__arc insurance-loader__arc--primary"
          />
          {/* Spinning arc - secondary */}
          <circle
            cx="50"
            cy="50"
            r="44"
            fill="none"
            className="insurance-loader__arc insurance-loader__arc--secondary"
          />
        </svg>
        <div className="insurance-loader__logo">
          <img src={tenantConfig.logoTransparent} alt={tenantConfig.name} />
        </div>
      </div>
      {message && <p className="insurance-loader__message">{message}</p>}
    </div>
  )
}

export default Loader
